import { render, staticRenderFns } from "./knowledgDetail.vue?vue&type=template&id=280c497c&scoped=true&"
import script from "./knowledgDetail.vue?vue&type=script&lang=js&"
export * from "./knowledgDetail.vue?vue&type=script&lang=js&"
import style0 from "./knowledgDetail.vue?vue&type=style&index=0&id=280c497c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c497c",
  null
  
)

export default component.exports